"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var components_1 = require("../../components");
var antd_1 = require("antd");
var form_item_1 = __importDefault(require("../form-item"));
var ReceiverRequirements_1 = require("../../types/ReceiverRequirements");
var react_intl_1 = require("react-intl");
var translationMessages = react_intl_1.defineMessages({
    deliveryLocation_title: {
        id: "deliveryLocation_title",
        defaultMessage: "Delivery location",
    },
    deliveryLocation_partyName: {
        id: "deliveryLocation_partyName",
        defaultMessage: "Party name",
    },
    deliveryLocation_streetNameAndNumber: {
        id: "deliveryLocation_streetNameAndNumber",
        defaultMessage: "Address"
    },
    deliveryLocation_postalZone: {
        id: "deliveryLocation_postalZone",
        defaultMessage: "Postal no"
    },
    deliveryLocation_city: {
        id: "deliveryLocation_city",
        defaultMessage: "Town/City"
    },
    deliveryLocation_countryCode: {
        id: "deliveryLocation_countryCode",
        defaultMessage: "Country code"
    }
});
var DeliveryLocation = function (props) {
    return (
    // props.intl.formatMessage(translationMessages.deliveryLocation_title)
    React.createElement(components_1.ComponentContainer, { title: "Afhendingarstaður" },
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["delivery.partyName"], 
            // props.intl.formatMessage(translationMessages.deliveryLocation_partyName)
            defaultLabel: "Nafn aðila", defaultIsRequired: false, fieldName: ["invoice", "delivery", "partyName"] },
            React.createElement(antd_1.Input, null)),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["delivery.address.streetNameAndNumber"], 
            // props.intl.formatMessage(translationMessages.deliveryLocation_streetNameAndNumber)
            defaultLabel: "Heimilisfang", defaultIsRequired: false, fieldName: ["invoice", "delivery", "address", "streetNameAndNumber"] },
            React.createElement(antd_1.Input, null)),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["delivery.address.postalZone"], 
            // props.intl.formatMessage(translationMessages.deliveryLocation_postalZone)
            defaultLabel: "Póstnúmer", defaultIsRequired: false, fieldName: ["invoice", "delivery", "address", "postalZone"] },
            React.createElement(antd_1.Input, null)),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, 
            // receiverRequirements={receiverRequirementsObject}
            receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["delivery.address.city"], 
            // props.intl.formatMessage(translationMessages.deliveryLocation_city)
            defaultLabel: "Bær/Borg", defaultIsRequired: false, fieldName: ["invoice", "delivery", "address", "city"] },
            React.createElement(antd_1.Input, null)),
        React.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["delivery.address.countryCode"], 
            // props.intl.formatMessage(translationMessages.deliveryLocation_countryCode)
            defaultLabel: "Landsnúmer", defaultIsRequired: true, fieldName: ["invoice", "delivery", "address", "countryCode"] },
            React.createElement(antd_1.Input, null))));
};
var DeliveryLocationIntl = react_intl_1.injectIntl(DeliveryLocation);
exports.default = DeliveryLocationIntl;
